import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import { getExporterJobHistory } from 'modules/api/inventory';
import { isCanceledError } from 'modules/api/request';
import { cancelFunctions } from 'utils/cancelFunctions';
import { addToastNotification } from 'store/notification/reducer';
import { getMarketId } from 'store/publisher/selectors';
import { ExportJob } from '../types/ExportJob.types';

interface Result {
  jobHistory: ExportJob[];
  setJobHistory: React.Dispatch<React.SetStateAction<ExportJob[]>>;
  refetchJobHistory: () => Promise<void>;
}

export const useExportJobHistory = (): Result => {
  const dispatch = useDispatch();
  const market = useSelector(getMarketId);
  const [jobHistory, setJobHistory] = useState<ExportJob[]>([]);

  const refetchJobHistory = useCallback(async (): Promise<void> => {
    try {
      const result = await getExporterJobHistory(market, cancelFunctions);
      setJobHistory(result);
    } catch (error) {
      if (isCanceledError(error)) return;

      dispatch(
        addToastNotification({
          header: 'Export history',
          description: 'Failed to fetch the export history. Please try again later.',
          type: 'Failure',
          timeout: 10000,
        }),
      );
    }
  }, [dispatch, market]);

  useEffect(() => {
    refetchJobHistory();
  }, [refetchJobHistory]);

  return { jobHistory, setJobHistory, refetchJobHistory };
};
